import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.22em] font-semibold text-brand ${className}`}
    >
      <span className="h-px w-6 bg-brand/50" />
      {children}
    </span>
  );
}
